var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFirmwareDrop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cellphone-arrow-down"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.75 1.25H5.25C4.85218 1.25 4.47064 1.40804 4.18934 1.68934C3.90804 1.97064 3.75 2.35218 3.75 2.75V16.25C3.75 16.6478 3.90804 17.0294 4.18934 17.3107C4.47064 17.592 4.85218 17.75 5.25 17.75H12.75C13.1478 17.75 13.5294 17.592 13.8107 17.3107C14.092 17.0294 14.25 16.6478 14.25 16.25V2.75C14.25 2.35218 14.092 1.97064 13.8107 1.68934C13.5294 1.40804 13.1478 1.25 12.75 1.25ZM12.75 14.75H5.25V4.25H12.75V14.75ZM12 10.25H9.75V6.5H8.25V10.25H6L9 13.25L12 10.25Z",
    fill: "#6B7280"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirmwareDrop);
export default __webpack_public_path__ + "static/media/firmwareDrop.76ce89b5e3c1a86cf7543fe3bc24bb4a.svg";
export { ForwardRef as ReactComponent };